import styled from "styled-components";

export const Container = styled.div`
display: flex;
justify-content: center;
align-items: center;
margin: 20px 0;
padding: 15px;
border: 2px solid rgb(21, 80, 255);
border-radius: 7px;
background-color: rgba(255,255,255, .5);
`
export const Label = styled.div`
font-size: 35px;
color: rgb(21, 80, 255);

`
export const Value = styled.div`
    font-size: 57px;
    font-weight: bold;
    color: #002e5b;
    text-shadow: -1px -1px 0px #FFF, -1px 1px 0px #FFF, 1px -1px 0px #FFF, 1px 0px 0px #FFF; 

`